module.exports = __webpack_public_path__ + "static/media/北京某部队综合楼-min.50b2fcd4.jpg";